import {BarcodescannerComponent} from './modals/barcodescanner/barcodescanner.component';
import {AuthenticationService} from './services/auth/authentication.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DatePicker} from '@ionic-native/date-picker/ngx';
import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CallNumber} from '@ionic-native/call-number/ngx';
import {Camera} from '@ionic-native/camera/ngx';
import {ImagePicker} from '@ionic-native/image-picker/ngx';
import {WebView} from '@ionic-native/ionic-webview/ngx';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {UrlEndpoints} from './definitions/url-endpoints';
import {RequestInterceptorService} from './services/auth/requestinterceptor.service';
import {FilePath} from '@ionic-native/file-path/ngx';
import {IonicStorageModule} from '@ionic/storage';
import {CustomerModel} from './models/customer.model';
import {SiteModel} from './models/site.model';
import {ContactModel} from './models/contact.model';
import {RandomColors} from './definitions/random-colors';
import {DetaillineDTOModel} from './models/detaillineDTO.model';
import {DatepickerComponent} from './components/datepicker/datepicker.component';
import {CustomerComponent} from './components/customer/customer.component';
import {GridrefComponent} from './components/gridref/gridref.component';
import {SiteComponent} from './components/site/site.component';
import {ContactdetailsComponent} from './components/contactdetails/contactdetails.component';
import {ItemsComponent} from './components/items/items.component';
import {PicturestakenComponent} from './components/picturestaken/picturestaken.component';
import {CommentsComponent} from './components/comments/comments.component';
import {SignatureComponent} from './components/signature/signature.component';
import {SearchcustomerPage} from './modals/searchcustomer/searchcustomer.page';
import {AddcustomerPage} from './modals/addcustomer/addcustomer.page';
import {SearchSitePage} from './modals/search-site/search-site.page';
import {AddSitePage} from './modals/add-site/add-site.page';
import {SearchContactPage} from './modals/search-contact/search-contact.page';
import {AddContactPage} from './modals/add-contact/add-contact.page';
import {TakePicturePage} from './modals/take-picture/take-picture.page';
import {ProductSelectPage} from './modals/product-select/product-select.page';
import {AddAccessoriesPage} from './modals/add-accessories/add-accessories.page';
import {OffhirePage} from './modals/offhire/offhire.page';
import {PipesModule} from './pipes/pipes.module';
import {PhotoDTOModel} from './models/photoDTO.model';
import {FormsModule} from '@angular/forms';
import {QueuedDocumentsPage} from './modals/queued-documents/queued-documents.page';
import {QueuedLiveContractsPage} from './modals/queued-live-contracts/queued-live-contracts.page';
import {QuotationPage} from './modals/quotation/quotation.page';
import {ServiceJobListPage} from './modals/service-job-list/service-job-list.page';
import {ServiceJobDetailsPage} from './modals/service-job-details/service-job-details.page';
import {CustomerRepairServiceJobDetailsPage} from './modals/customer-repair-service-job-details/customer-repair-service-job-details.page';
import {JobDetailsComponent} from './components/job-details/job-details.component';
import {TimeClockingComponent} from './components/time-clocking/time-clocking.component';
import {TasksListComponent} from './components/tasks-list/tasks-list.component';
import {CustomerDetailsComponent} from './components/customer-details/customer-details.component';
import {PartsForServiceComponent} from './components/parts-for-service/parts-for-service.component';
import {DetailsExistingJobComponent} from './components/details-existing-job/details-existing-job.component';
import {MetersReadingsTakenComponent} from './components/meters-readings-taken/meters-readings-taken.component';
import {SimpleSignatureComponent} from './components/simple-signature/simple-signature.component';
import {JobCertificateComponent} from './components/job-certificate/job-certificate.component';
import {MeterReadingsPage} from './modals/meter-readings/meter-readings.page';
import {OrdersPage} from './modals/orders/orders.page';
import {OpportunityPage} from './modals/opportunity/opportunity.page';
import {SelectDocumentTypeComponent} from './components/select-document-type/select-document-type.component';
import {OrdersForCustomerPage} from './modals/orders-for-customer/orders-for-customer.page';
import {SelectPlantComponent} from './components/select-plant/select-plant.component';
import {CustomerReturnComponent} from './components/customer-return/customer-return.component';
import {ItemsReturnComponent} from './components/items-return/items-return.component';
import {CallLogPage} from './modals/call-log/call-log.page';
import {CallLog} from '@ionic-native/call-log/ngx';
import {ReturnPage} from './modals/return/return.page';
import {AddTransportPage} from './modals/add-transport/add-transport.page';
import {Geolocation} from '@ionic-native/geolocation/ngx';
import {LoadingModalPage} from './modals/loading-modal/loading-modal.page';
import {Base64} from '@ionic-native/base64/ngx';
import {LegacyJobDetailPage} from './modals/legacy-job-detail/legacy-job-detail.page';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {EquipmentSelectScaffoldingPage} from './modals/scaffolding/equipment-select-scaffolding/equipment-select-scaffolding.page';
import {ItemsScaffoldingComponent} from './components/items-scaffolding/items-scaffolding.component';
import {ExistingOrderLinesComponent} from './components/existing-order-lines/existing-order-lines.component';
import {ItemsOrderFulfilmentComponent} from './components/items-order-fulfilment/items-order-fulfilment.component';
import {OrderFulfilSpecificItemPage} from './modals/order-fulfil-specific-item/order-fulfil-specific-item.page';
import {ItemsReturnScaffoldingComponent} from './components/items-return-scaffolding/items-return-scaffolding.component';
import {EquipListReturnScaffoldingPage} from './modals/scaffolding/equip-list-return-scaffolding/equip-list-return-scaffolding.page';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {SelectQueueOperatorComponent} from './components/select-queue-operator/select-queue-operator.component';
import {BlankSignature} from './definitions/blank-signature';
import {DummyOperators} from './definitions/dummy-operators';
import {SignNowOrLaterComponent} from './components/sign-now-or-later/sign-now-or-later.component';
import {Vibration} from '@ionic-native/vibration/ngx';
import {ContractScaffoldingPage} from './modals/scaffolding/contract-scaffolding/contract-scaffolding.page';
import {SignDocumentPage} from './modals/sign-document/sign-document.page';
import {OrdersScaffoldingPage} from './modals/scaffolding/orders-scaffolding/orders-scaffolding.page';
import {ReturnScaffoldingPage} from './modals/scaffolding/return-scaffolding/return-scaffolding.page';
import {OffhireScaffoldingPage} from './modals/scaffolding/offhire-scaffolding/offhire-scaffolding.page';
import {QuotationScaffoldingPage} from './modals/scaffolding/quotation-scaffolding/quotation-scaffolding.page';
import {LegacyJobHistoryDetailPage} from './modals/legacy-job-history-detail/legacy-job-history-detail.page';
import {LocationSelectComponent} from './components/location-select/location-select.component';
import {SelectProductSerialPage} from './modals/select-product-serial/select-product-serial.page';
import {InvoicePage} from './modals/invoice/invoice.page';
import {AppUpdate} from '@ionic-native/app-update/ngx';
import {AppVersion} from '@ionic-native/app-version/ngx';
import {PaymentComponent} from './components/payment/payment.component';
import {PaymentPage} from './modals/payment/payment.page';
import {ConfigurationDefault} from './definitions/configuration-default';
import {QuestionsPage} from './modals/questions/questions.page';
import {DocumentTypes} from './definitions/document-types';
import {HmheadDocTypes} from './definitions/hmhead-doctypes';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {OrderNumberComponent} from './components/order-number/order-number.component';
import {FuelValues} from './definitions/fuel-values';
import {ErrorHandlerService} from './services/error-handler.service';
import {EmailComposer} from '@ionic-native/email-composer/ngx';
import {ActionDetails} from './modals/action-details/action-details';
import {QueueStatus} from './definitions/queue-status';
import {FilterPanelComponent} from './components/filter-panel/filter-panel.component';
import {ScreenPreferencesDefault} from './definitions/screen-preferences-default';
import {CollectionsNames} from './definitions/collections-names';
import {ContractHealthCare} from './modals/healthcare/contract-health-care/contract-health-care';
import {PatientInfoComponent} from './components/patient-info/patient-info.component';
import {OffhireHealthCarePage} from './modals/healthcare/offhire-health-care/offhire-health-care.page';
import {SignDocumentHealthCarePage} from './modals/healthcare/sign-document-health-care/sign-document-health-care.page';
import {StockingHealthCarePage} from './modals/healthcare/stocking-health-care/stocking-health-care.page';
import {EquipListReturnPage} from './modals/equip-list-return/equip-list-return.page';
import {EquipmentListPage} from './modals/equipment-list/equipment-list.page';
import {EquipmentSelect} from './modals/equipment-select/equipment-select';
import {DocumentTypeModalPage} from './modals/document-type-modal/document-type-modal.page';
import {ContractPage} from './modals/contract/contract.page';
import {DrawSignaturePage} from './modals/draw-signature/draw-signature.page';
import {ConsumablesReturnPage} from './modals/consumables-return/consumables-return.page';
import {ErrorLogPage} from './modals/error-log/error-log.page';
import {OrdersHealthCare} from './modals/healthcare/orders-health-care/orders.health-care';
import {GestureHandlerService} from './services/gesture-handler.service';
import {Network} from '@ionic-native/network/ngx';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {CollectionWithBarcodeComponent} from './modals/collection-with-barcode/collection-with-barcode.component';
import {DetailLinesToBeCollectedComponent} from './modals/detail-lines-to-be-collected/detail-lines-to-be-collected.component';
import {StockTakeMainComponent} from './modals/stock-take-main/stock-take-main.component';
import {StockTakeDetailComponent} from './modals/stock-take-detail/stock-take-detail.component';
import {StockTakeBarcodeComponent} from './modals/stock-take-barcode/stock-take-barcode.component';
import {StockTakeProductsManualComponent} from './modals/stock-take-products-manual/stock-take-products-manual.component';
import {CheckWardHealthCareComponent} from './modals/healthcare/check-ward/check-ward-health-care.component';
import {ScanBarcodeCheckWardComponent} from './modals/healthcare/scan-barcode-check-ward/scan-barcode-check-ward.component';
import {EquipmentInfoModalComponent} from './modals/healthcare/equipment-info-modal/equipment-info-modal.component';
import {ProductMultiSelectComponent} from './modals/product-multi-select/product-multi-select.component';
import {SparesFuelWsComponent} from './components/spares-fuel-ws/spares-fuel-ws.component';
import {CheckPlantItemServiceHistoryComponent} from './modals/check-plant-item-service-history/check-plant-item-service-history.component';
import {CustomerContactDetailsOpportunityComponent} from './components/customer-contact-details-opportunity/customer-contact-details-opportunity.component';
import {EquipmentMultiSelectComponent} from './modals/equipment-multi-select/equipment-multi-select.component';
import {EditPlantItemModalComponent} from './modals/edit-plant-item-modal/edit-plant-item-modal.component';
import {SignatureCaptureModeComponent} from './modals/counter-signing/signature-capture-mode/signature-capture-mode.component';
import {OptionsHandlerService} from './services/optionshandler.service';
import {ContractAndCollectionComponent} from './modals/healthcare/contract-and-collection/contract-and-collection.component';
import {BufferedStockConciliationComponent} from './modals/healthcare/buffered-stock-conciliation/buffered-stock-conciliation.component';
import {ChangeoverComponent} from './modals/healthcare/changeover/changeover.component';
import {CheckHospitalStockComponent} from './modals/healthcare/check-hospital-stock/check-hospital-stock.component';
import {BarcodeOptions} from './definitions/barcode-options';
import {PurchaseOrderComponent} from './modals/purchase-order/purchase-order.component';
import { SelectBinLocationPage } from './modals/select-bin-location/select-bin-location.page';
import { BinLocationModel } from './models/bin-location.model';
import { BinLocationComponent } from './components/bin-location/bin-location.component';
import { EditPhotoComponent } from './modals/edit-photo/edit-photo.component';
import { ManualRefComponent } from './components/manual-ref/manual-ref.component';

@NgModule({
    imports: [
        BrowserModule,
        IonicModule.forRoot(
            {}
        ),
        AppRoutingModule,
        HttpClientModule,
        PipesModule,
        FormsModule,
        ZXingScannerModule,
        IonicStorageModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        HammerModule
    ],
    declarations: [
        AppComponent,
        ContractPage,
        DatepickerComponent,
        CustomerComponent,
        GridrefComponent,
        SiteComponent,
        ContactdetailsComponent,
        BinLocationComponent,
        ItemsComponent,
        PicturestakenComponent,
        CommentsComponent,
        ManualRefComponent,
        SignatureComponent,
        SearchcustomerPage,
        AddcustomerPage,
        SearchSitePage,
        AddSitePage,
        SearchContactPage,
        SelectBinLocationPage,
        AddContactPage,
        TakePicturePage,
        EquipmentListPage,
        DrawSignaturePage,
        ProductSelectPage,
        EquipmentSelect,
        AddAccessoriesPage,
        OffhirePage,
        QueuedDocumentsPage,
        QueuedLiveContractsPage,
        QuotationPage,
        ServiceJobListPage,
        ServiceJobDetailsPage,
        CustomerRepairServiceJobDetailsPage,
        JobDetailsComponent,
        TimeClockingComponent,
        TasksListComponent,
        CustomerDetailsComponent,
        PartsForServiceComponent,
        DetailsExistingJobComponent,
        MetersReadingsTakenComponent,
        SimpleSignatureComponent,
        JobCertificateComponent,
        MeterReadingsPage,
        OrdersPage,
        OpportunityPage,
        SelectDocumentTypeComponent,
        OrdersForCustomerPage,
        SelectPlantComponent,
        CustomerReturnComponent,
        ItemsReturnComponent,
        EquipListReturnPage,
        CallLogPage,
        ReturnPage,
        AddTransportPage,
        LoadingModalPage,
        LegacyJobDetailPage,
        EquipmentSelectScaffoldingPage,
        ItemsScaffoldingComponent,
        ExistingOrderLinesComponent,
        ItemsOrderFulfilmentComponent,
        OrderFulfilSpecificItemPage,
        EquipListReturnScaffoldingPage,
        ItemsReturnScaffoldingComponent,
        OrderFulfilSpecificItemPage,
        BarcodescannerComponent,
        DocumentTypeModalPage,
        SelectQueueOperatorComponent,
        SignNowOrLaterComponent,
        ContractScaffoldingPage,
        SignDocumentPage,
        OrdersScaffoldingPage,
        ReturnScaffoldingPage,
        OffhireScaffoldingPage,
        QuotationScaffoldingPage,
        LegacyJobHistoryDetailPage,
        LocationSelectComponent,
        InvoicePage,
        LocationSelectComponent,
        SelectProductSerialPage,
        PaymentComponent,
        PaymentPage,
        QuestionsPage,
        OrderNumberComponent,
        ErrorLogPage,
        ActionDetails,
        FilterPanelComponent,
        ConsumablesReturnPage,
        ContractHealthCare,
        PatientInfoComponent,
        OffhireHealthCarePage,
        SignDocumentHealthCarePage,
        StockingHealthCarePage,
        OrdersHealthCare,
        CollectionWithBarcodeComponent,
        DetailLinesToBeCollectedComponent,
        StockTakeMainComponent,
        StockTakeDetailComponent,
        StockTakeBarcodeComponent,
        StockTakeProductsManualComponent,
        CheckWardHealthCareComponent,
        ScanBarcodeCheckWardComponent,
        EquipmentInfoModalComponent,
        ProductMultiSelectComponent,
        SparesFuelWsComponent,
        CheckPlantItemServiceHistoryComponent,
        CustomerContactDetailsOpportunityComponent,
        EquipmentMultiSelectComponent,
        EditPlantItemModalComponent,
        SignatureCaptureModeComponent,
        ContractAndCollectionComponent,
        BufferedStockConciliationComponent,
        ChangeoverComponent,
        CheckHospitalStockComponent,
        PurchaseOrderComponent,
        EditPhotoComponent
    ],
    entryComponents: [
        ContractPage,
        SearchcustomerPage,
        AddcustomerPage,
        SearchSitePage,
        AddSitePage,
        SearchContactPage,
        SelectBinLocationPage,
        AddContactPage,
        TakePicturePage,
        EquipmentListPage,
        DrawSignaturePage,
        ProductSelectPage,
        EquipmentSelect,
        AddAccessoriesPage,
        OffhirePage,
        QueuedDocumentsPage,
        QueuedLiveContractsPage,
        QuotationPage,
        ServiceJobListPage,
        ServiceJobDetailsPage,
        CustomerRepairServiceJobDetailsPage,
        MeterReadingsPage,
        OrdersPage,
        OpportunityPage,
        OrdersForCustomerPage,
        EquipListReturnPage,
        CallLogPage,
        ReturnPage,
        AddTransportPage,
        LoadingModalPage,
        LegacyJobDetailPage,
        EquipmentSelectScaffoldingPage,
        OrderFulfilSpecificItemPage,
        BarcodescannerComponent,
        OrderFulfilSpecificItemPage,
        EquipListReturnScaffoldingPage,
        DocumentTypeModalPage,
        ContractScaffoldingPage,
        SignDocumentPage,
        OrdersScaffoldingPage,
        ReturnScaffoldingPage,
        OffhireScaffoldingPage,
        LegacyJobHistoryDetailPage,
        InvoicePage,
        LegacyJobHistoryDetailPage,
        SelectProductSerialPage,
        PaymentPage,
        QuestionsPage,
        ErrorLogPage,
        ActionDetails,
        FilterPanelComponent,
        ConsumablesReturnPage,
        ContractHealthCare,
        OffhireHealthCarePage,
        SignDocumentHealthCarePage,
        StockingHealthCarePage,
        OrdersHealthCare,
        CollectionWithBarcodeComponent,
        DetailLinesToBeCollectedComponent,
        StockTakeMainComponent,
        StockTakeDetailComponent,
        StockTakeBarcodeComponent,
        StockTakeProductsManualComponent,
        CheckWardHealthCareComponent,
        ScanBarcodeCheckWardComponent,
        EquipmentInfoModalComponent,
        ProductMultiSelectComponent,
        CheckPlantItemServiceHistoryComponent,
        EquipmentMultiSelectComponent,
        EditPlantItemModalComponent,
        SignatureCaptureModeComponent,
        ContractAndCollectionComponent,
        BufferedStockConciliationComponent,
        ChangeoverComponent,
        CheckHospitalStockComponent,
        PurchaseOrderComponent,
        EditPhotoComponent
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true},
        {provide: ErrorHandler, useClass: ErrorHandlerService},
        {provide: HAMMER_GESTURE_CONFIG, useClass: GestureHandlerService},
        StatusBar,
        SplashScreen,
        DatePicker,
        CallNumber,
        CallLog,
        Camera,
        ImagePicker,
        WebView,
        UrlEndpoints,
        RandomColors,
        ScreenOrientation,
        AuthenticationService,
        FilePath,
        CustomerModel,
        SiteModel,
        ContactModel,
        ScreenOrientation,
        RandomColors,
        DetaillineDTOModel,
        PhotoDTOModel,
        Geolocation,
        Base64,
        BlankSignature,
        DummyOperators,
        Vibration,
        BarcodeScanner,
        AppUpdate,
        AppVersion,
        ConfigurationDefault,
        DocumentTypes,
        HmheadDocTypes,
        FuelValues,
        EmailComposer,
        QueueStatus,
        ScreenPreferencesDefault,
        CollectionsNames,
        Network,
        AndroidPermissions,
        OptionsHandlerService,
        BarcodeOptions,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy}
    ],
    exports: [
        CustomerComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
